import _defineProperty2 from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(typeof e + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
import './PassportDetails.css';
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { forOwn, isEmpty } from 'lodash';
import { RichText, Text } from '@sitecore-jss/sitecore-jss-react';
import { TextInput, Select, Date as DateField } from './components/FormFields';
import Modal from './components/Modal';
import ActionsPanel from '../ActionsPanel';
import { getDictionaryItem, get } from '../../../../utils';
import { IdndividualProfileInquiry, SaveLongTourismEntryPermit } from '../actions';
import Loader from '../loader';
import { IconWarning } from '../../../atoms/Icons/';
import { searchPasportFieldMapping } from '../constants';
import { format, isValid, parse } from 'date-fns';
var StepRender = function StepRender(props) {
  var context = props.context,
    updateContext = props.updateContext,
    updateSteps = props.updateSteps,
    currentStepId = props.currentStepId,
    stepConfig = props.stepConfig,
    _props$rtl = props.rtl,
    rtl = _props$rtl === void 0 ? false : _props$rtl,
    setTranslateValue = props.setTranslateValue,
    getTranslateValue = props.getTranslateValue,
    generateStepData = props.generateStepData,
    validateCurrentFields = props.validateCurrentFields,
    getLookupOptions = props.getLookupOptions,
    appRef = props.appRef,
    apiConfig = props.apiConfig,
    applicationNumber = props.applicationNumber,
    isTranslateAvaible = props.isTranslateAvaible,
    setIsTranslateAvaible = props.setIsTranslateAvaible,
    setDocuments = props.setDocuments,
    isLoadingWizard = props.isLoadingWizard;
  var _stepConfig$data = stepConfig.data,
    title = _stepConfig$data.title,
    buttonBackUrl = _stepConfig$data.buttonBackUrl,
    availableNationalities = _stepConfig$data.availableNationalities,
    pdMessage = _stepConfig$data.pdMessage,
    policyMessage = _stepConfig$data.policyMessage,
    countriesExemptedFromTranslations = _stepConfig$data.countriesExemptedFromTranslations.targetItems,
    dictionary = stepConfig.dictionary,
    validateMessage = stepConfig.validateMessage,
    dictionaryNavigation = stepConfig.dictionaryNavigation;
  var PASSPORT_RULES_FIELD = 'passportIssueCountryId';
  var history = useHistory();
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    requiredRule = _useState2[0],
    setRequiredRule = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    errorServerMessage = _useState4[0],
    setErrorServerMessage = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    showModal = _useState6[0],
    setShowModal = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    validateRule = _useState8[0],
    setValidateRule = _useState8[1];
  var _useState9 = useState(false),
    _useState10 = _slicedToArray(_useState9, 2),
    validate = _useState10[0],
    setValidate = _useState10[1];
  var _useState11 = useState(false),
    _useState12 = _slicedToArray(_useState11, 2),
    validFormPassport = _useState12[0],
    setValidFormPassport = _useState12[1];
  var _useState13 = useState(false),
    _useState14 = _slicedToArray(_useState13, 2),
    validForm = _useState14[0],
    setValidForm = _useState14[1];
  var _useState15 = useState(false),
    _useState16 = _slicedToArray(_useState15, 2),
    isRequesting = _useState16[0],
    setIsRequesting = _useState16[1];
  var _useState17 = useState(false),
    _useState18 = _slicedToArray(_useState17, 2),
    isSendingForm = _useState18[0],
    setIsSendingForm = _useState18[1];
  var _useState19 = useState(false),
    _useState20 = _slicedToArray(_useState19, 2),
    passporNotFoundtMessage = _useState20[0],
    setPassporNotFoundtMessage = _useState20[1];
  var dashboardUrl = get(buttonBackUrl, 'jss.value.href') || '/';
  var nextStepId = currentStepId + 1;
  var pasportRuleFields = [{
    name: 'passportNo',
    required: true
  }, {
    name: 'passportTypeId',
    required: true
  }, {
    name: 'currentNationalityId',
    required: true
  }, {
    name: 'birthDate',
    required: true
  }, {
    name: PASSPORT_RULES_FIELD,
    required: true
  }];
  var fieldsList = [{
    apiName: 'genderId',
    name: 'Gender',
    type: 'select',
    required: true
  }, {
    apiName: 'lastNameEN',
    name: 'LastName',
    type: 'text',
    required: true,
    relatedFieldName: 'lastNameAR'
  }, {
    apiName: 'lastNameAR',
    name: 'LastNameInArabic',
    type: 'text',
    required: true,
    relatedFieldName: 'lastNameEN'
  }, {
    apiName: 'passportExpiryDate',
    name: 'PassportExpiryDate',
    type: 'date',
    required: true
  }, {
    apiName: 'passportIssueDate',
    name: 'PassportIssueDate',
    type: 'date',
    required: true
  }, {
    apiName: 'passportPlaceAR',
    name: 'PassportPlaceOfIssueInArabic',
    type: 'text',
    required: true,
    relatedFieldName: 'passportPlaceEN'
  }, {
    apiName: 'passportTypeId',
    name: 'PassportType',
    type: 'select',
    required: true,
    selectOptionName: 'passportType'
  }, {
    apiName: 'passportPlaceEN',
    name: 'PassportPlaceOfIssueInEnglish',
    type: 'text',
    required: true,
    relatedFieldName: 'passportPlaceAR'
  }, {
    apiName: 'passportNo',
    name: 'PassportNumber',
    type: 'text',
    required: true
  }, {
    apiName: 'passportIssueCountryId',
    name: 'PassportIssueCountry',
    selectOptionName: 'country',
    type: 'select',
    required: true
  }, {
    apiName: 'firstNameEN',
    name: 'FirstName',
    type: 'text',
    required: true,
    relatedFieldName: 'firstNameAR'
  }, {
    apiName: 'firstNameAR',
    name: 'FirstNameInArabic',
    type: 'text',
    required: true,
    relatedFieldName: 'firstNameEN'
  }, {
    apiName: 'middleNameEN',
    name: 'MiddleName',
    type: 'text',
    required: false,
    relatedFieldName: 'middleNameAR'
  }, {
    apiName: 'middleNameAR',
    name: 'MiddleNameInArabic',
    type: 'text',
    required: false,
    relatedFieldName: 'middleNameEN'
  }, {
    apiName: 'birthDate',
    name: 'DateOfBirth',
    type: 'date',
    required: true
  }, {
    apiName: 'birthPlaceEN',
    name: 'BirthPlaceInEnglish',
    type: 'text',
    required: true,
    relatedFieldName: 'birthPlaceAR'
  }, {
    apiName: 'birthPlaceAR',
    name: 'BirthPlaceInArabic',
    type: 'text',
    required: true,
    relatedFieldName: 'birthPlaceEN'
  }, {
    apiName: 'currentNationalityId',
    name: 'CurrentNationality',
    type: 'select',
    selectOptionName: 'country',
    required: true
  }, {
    apiName: 'previousNationalityId',
    name: 'PreviousNationality',
    type: 'select',
    selectOptionName: 'country',
    required: true,
    staticName: 'Previous Nationality * (static label)'
  }];
  var panelButtonState = {
    continue: {
      inactive: !validForm,
      loading: isLoadingWizard,
      label: getDictionaryItem(dictionaryNavigation, 'NavigationContinue')
    },
    back: {
      inactive: false,
      label: getDictionaryItem(dictionaryNavigation, 'NavigationBack')
    },
    save: {
      inactive: !(applicationNumber && applicationNumber.length && validForm),
      loading: isSendingForm,
      label: getDictionaryItem(dictionaryNavigation, 'NavigationSave')
    }
  };
  var panelActions = {
    contionueAction: function contionueAction() {
      if (openModal()) return;
      updateSteps(nextStepId);
    },
    saveAction: function () {
      var _saveAction = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(applicationNumber && applicationNumber.length)) {
                _context.next = 6;
                break;
              }
              if (!(validateCurrentFields && validateCurrentFields(fieldsList))) {
                _context.next = 4;
                break;
              }
              setValidate(true);
              return _context.abrupt("return");
            case 4:
              _context.next = 6;
              return submitData(false, applicationNumber);
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      function saveAction() {
        return _saveAction.apply(this, arguments);
      }
      return saveAction;
    }(),
    backAction: function backAction() {
      history.push(dashboardUrl);
    }
  };
  var submitData = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(isDraft, appId) {
      var _yield$SaveLongTouris, _yield$SaveLongTouris2, applicationNumber, _yield$SaveLongTouris3, documents, _yield$SaveLongTouris4, isSuccess, error, errorMessage;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            setErrorServerMessage('');
            setIsSendingForm(true);
            _context2.next = 4;
            return SaveLongTourismEntryPermit(apiConfig, context, isDraft, appId);
          case 4:
            _yield$SaveLongTouris = _context2.sent;
            _yield$SaveLongTouris2 = _yield$SaveLongTouris.applicationNumber;
            applicationNumber = _yield$SaveLongTouris2 === void 0 ? '' : _yield$SaveLongTouris2;
            _yield$SaveLongTouris3 = _yield$SaveLongTouris.documents;
            documents = _yield$SaveLongTouris3 === void 0 ? [] : _yield$SaveLongTouris3;
            _yield$SaveLongTouris4 = _yield$SaveLongTouris.isSuccess;
            isSuccess = _yield$SaveLongTouris4 === void 0 ? false : _yield$SaveLongTouris4;
            error = _yield$SaveLongTouris.error;
            console.log('error', error);
            setIsSendingForm(false);
            if (isEmpty(error)) {
              _context2.next = 18;
              break;
            }
            errorMessage = rtl && error.ar ? error.ar : error.en || '';
            setErrorServerMessage(errorMessage.replaceAll(',', '\n'));
            return _context2.abrupt("return", false);
          case 18:
            if (!(isSuccess && applicationNumber.length)) {
              _context2.next = 21;
              break;
            }
            setDocuments(documents);
            return _context2.abrupt("return", true);
          case 21:
            return _context2.abrupt("return", false);
          case 22:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function submitData(_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
  var resetFormData = function resetFormData() {
    forOwn(context, function (item) {
      var _item$name = item.name,
        name = _item$name === void 0 ? '' : _item$name,
        required = item.required;
      var passportItem = pasportRuleFields.find(function (_ref2) {
        var passportFieldName = _ref2.name;
        return passportFieldName === name;
      });
      if (passportItem) return;
      updateContext(_defineProperty2({}, name, _objectSpread(_objectSpread({}, item), {}, {
        value: '',
        valid: !required
      })));
    });
  };
  var validateRequiredRule = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
      var translateCheck, _yield$IdndividualPro, data, status;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            if (!(validateCurrentFields && validateCurrentFields(pasportRuleFields))) {
              _context3.next = 3;
              break;
            }
            setValidateRule(true);
            return _context3.abrupt("return");
          case 3:
            if (!openModal()) {
              _context3.next = 5;
              break;
            }
            return _context3.abrupt("return");
          case 5:
            resetFormData();
            translateCheck = checkAvaibleTranslantation();
            setIsTranslateAvaible(translateCheck);
            setIsRequesting(true);
            _context3.next = 11;
            return IdndividualProfileInquiry(apiConfig, context);
          case 11:
            _yield$IdndividualPro = _context3.sent;
            data = _yield$IdndividualPro.data;
            status = _yield$IdndividualPro.status;
            if (isEmpty(data) || status !== 200) setPassporNotFoundtMessage(true);else setPassporNotFoundtMessage(false);
            forOwn(data, function (value, fieldName) {
              var name = fieldName;
              var computedValue = value;
              if (value.id) {
                name = fieldName + 'Id';
                computedValue = value.id;
              }
              var apiName = name;
              if (!searchPasportFieldMapping[name]) return;
              apiName = searchPasportFieldMapping[name] || name;
              if (apiName === 'birthDate' && !isValid(new Date(computedValue.replaceAll('-', '/')))) {
                computedValue = format(parse('27-02-2000', 'dd-MM-yyyy', new Date()), 'yyyy-MM-dd');
              }
              updateContext(_defineProperty2({}, apiName, _objectSpread(_objectSpread({}, context[apiName]), {}, {
                value: computedValue,
                valid: true
              })));
            });
            setIsRequesting(false);
            setRequiredRule(true);
          case 18:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return function validateRequiredRule() {
      return _ref3.apply(this, arguments);
    };
  }();
  var getCurrentOptionCountry = function getCurrentOptionCountry() {
    var item = context[PASSPORT_RULES_FIELD];
    var selectOptionName = item.selectOptionName;
    var options = getLookupOptions && getLookupOptions(selectOptionName) || [];
    return options.find(function (_ref4) {
      var lookupId = _ref4.lookupId;
      return String(lookupId) === String(item.value);
    });
  };
  var checkAvaibleTranslantation = function checkAvaibleTranslantation() {
    var _getCurrentOptionCoun = getCurrentOptionCountry(),
      _getCurrentOptionCoun2 = _getCurrentOptionCoun.lookupId,
      lookupId = _getCurrentOptionCoun2 === void 0 ? 'null' : _getCurrentOptionCoun2;
    return !countriesExemptedFromTranslations.find(function (_ref5) {
      var _ref5$key$value = _ref5.key.value,
        value = _ref5$key$value === void 0 ? '' : _ref5$key$value;
      return String(value) === String(lookupId);
    });
  };
  var openModal = function openModal() {
    var currentOption = getCurrentOptionCountry();
    var checkCurrentCountry = availableNationalities.find(function (_ref6) {
      var _ref6$countryName$jss = _ref6.countryName.jss.value,
        value = _ref6$countryName$jss === void 0 ? '' : _ref6$countryName$jss;
      return value.toLowerCase() === (rtl ? currentOption.name.ar.toLowerCase() : currentOption.name.en.toLowerCase());
    });
    if (!checkCurrentCountry) {
      setShowModal(true);
      return true;
    }
    return false;
  };
  useEffect(function () {
    generateStepData && generateStepData(fieldsList, dictionary);
    appRef && appRef.current.scrollIntoView({
      behavior: 'smooth'
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(function () {
    if (validForm) setRequiredRule(true);
  }, [validForm]);
  useEffect(function () {
    applicationNumber && applicationNumber.length && setRequiredRule(true);
  }, [applicationNumber]);
  useEffect(function () {
    if (validateCurrentFields && !validateCurrentFields(fieldsList)) setValidForm(true);else setValidForm(false);
    if (validateCurrentFields && !validateCurrentFields(pasportRuleFields)) setValidFormPassport(true);else setValidFormPassport(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [context]);
  return /*#__PURE__*/React.createElement("div", {
    className: " ".concat(commonStyles, " ").concat(rtl ? rtlStyles : ltrStyles)
  }, /*#__PURE__*/React.createElement("div", {
    className: "wizard__body"
  }, /*#__PURE__*/React.createElement("div", {
    className: "module-header"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row "
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-12"
  }, /*#__PURE__*/React.createElement("div", {
    className: ""
  }, /*#__PURE__*/React.createElement(Text, {
    tag: "h2",
    className: 'h2',
    field: title || {
      value: ''
    }
  }))))), /*#__PURE__*/React.createElement("div", {
    className: "module-group-app module-group-app--inside"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-lg-4 col-md-6 form-field"
  }, /*#__PURE__*/React.createElement(Select, _extends({}, context['passportTypeId'], {
    updateContext: updateContext,
    validate: validateRule,
    patternInvalidMessage: validateMessage,
    options: getLookupOptions && getLookupOptions('passportType') || [],
    rtl: rtl
  }))), /*#__PURE__*/React.createElement("div", {
    className: "col-lg-4  col-md-6  form-field"
  }, /*#__PURE__*/React.createElement(TextInput, _extends({
    rtl: rtl
  }, context['passportNo'], {
    updateContext: updateContext,
    validate: validateRule,
    patternInvalidMessage: validateMessage,
    patternRegex: /^(?!^0+$)[a-zA-Z0-9]{3,20}$/
  }))), /*#__PURE__*/React.createElement("div", {
    className: "col-lg-4  col-md-6  form-field"
  }, /*#__PURE__*/React.createElement(Select, _extends({}, context['currentNationalityId'], {
    updateContext: updateContext,
    validate: validateRule,
    patternInvalidMessage: validateMessage,
    options: getLookupOptions && getLookupOptions('country') || [],
    rtl: rtl
  }))), /*#__PURE__*/React.createElement("div", {
    className: "col-lg-4  col-md-6  form-field"
  }, /*#__PURE__*/React.createElement(DateField, _extends({
    dateFormat: "yyyy-mm-dd"
  }, context['birthDate'], {
    updateContext: updateContext,
    validate: validateRule,
    patternInvalidMessage: validateMessage,
    rtl: rtl,
    isOnlyPast: true
  }))), /*#__PURE__*/React.createElement("div", {
    className: "col-lg-4  col-md-6  form-field"
  }, /*#__PURE__*/React.createElement(Select, _extends({}, context['passportIssueCountryId'], {
    updateContext: updateContext,
    validate: validate,
    patternInvalidMessage: validateMessage,
    options: getLookupOptions && getLookupOptions('country') || [],
    rtl: rtl
  }))), /*#__PURE__*/React.createElement("div", {
    className: "col-lg-4  col-md-6 form-field form-button"
  }, /*#__PURE__*/React.createElement("button", {
    className: "btn btn-primary ".concat(isLoadingWizard || !validFormPassport ? 'disabled' : ''),
    onClick: validateRequiredRule
  }, isRequesting ? /*#__PURE__*/React.createElement(Loader, null) : getDictionaryItem(dictionary, 'SearchPassportData') || 'Search passport data')), passporNotFoundtMessage && /*#__PURE__*/React.createElement("div", {
    className: "col-md-12"
  }, /*#__PURE__*/React.createElement("div", {
    className: "message"
  }, /*#__PURE__*/React.createElement(IconWarning, null), /*#__PURE__*/React.createElement(RichText, {
    field: _objectSpread({}, get(pdMessage, 'jss'))
  }))), requiredRule && /*#__PURE__*/React.createElement("div", {
    className: "col-md-12"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-lg-4 col-md-6  form-field"
  }, /*#__PURE__*/React.createElement(TextInput, _extends({
    setTranslateValue: setTranslateValue
  }, context['firstNameEN'], {
    updateContext: updateContext,
    validate: validate,
    patternInvalidMessage: validateMessage,
    isTranslateAvaible: isTranslateAvaible,
    rtl: rtl
  }))), /*#__PURE__*/React.createElement("div", {
    className: "col-lg-4 col-md-6  form-field"
  }, /*#__PURE__*/React.createElement(TextInput, _extends({
    getTranslateValue: getTranslateValue,
    updateContext: updateContext
  }, context['firstNameAR'], {
    validate: validate,
    patternInvalidMessage: validateMessage,
    isTranslateAvaible: isTranslateAvaible,
    rtl: rtl
  }))), /*#__PURE__*/React.createElement("div", {
    className: "col-lg-4 col-md-6  form-field"
  }, /*#__PURE__*/React.createElement(Select, _extends({}, context['genderId'], {
    updateContext: updateContext,
    validate: validate,
    patternInvalidMessage: validateMessage,
    options: getLookupOptions && getLookupOptions('gender') || [],
    isString: true,
    rtl: rtl
  }))), /*#__PURE__*/React.createElement("div", {
    className: "col-lg-4 col-md-6  form-field"
  }, /*#__PURE__*/React.createElement(TextInput, _extends({
    setTranslateValue: setTranslateValue
  }, context['middleNameEN'], {
    updateContext: updateContext,
    validate: validate,
    patternInvalidMessage: validateMessage,
    isTranslateAvaible: isTranslateAvaible,
    rtl: rtl
  }))), /*#__PURE__*/React.createElement("div", {
    className: "col-lg-4 col-md-6  form-field"
  }, /*#__PURE__*/React.createElement(TextInput, _extends({
    rtl: rtl,
    getTranslateValue: getTranslateValue,
    updateContext: updateContext
  }, context['middleNameAR'], {
    validate: validate,
    patternInvalidMessage: validateMessage,
    isTranslateAvaible: isTranslateAvaible
  }))), /*#__PURE__*/React.createElement("div", {
    className: "col-lg-4 col-md-6  form-field"
  }, /*#__PURE__*/React.createElement(Select, _extends({}, context['previousNationalityId'], {
    updateContext: updateContext,
    validate: validate,
    patternInvalidMessage: validateMessage,
    options: getLookupOptions && getLookupOptions('country') || [],
    isString: true,
    rtl: rtl
  }))), /*#__PURE__*/React.createElement("div", {
    className: "col-lg-4 col-md-6  form-field"
  }, /*#__PURE__*/React.createElement(TextInput, _extends({
    setTranslateValue: setTranslateValue
  }, context['lastNameEN'], {
    updateContext: updateContext,
    validate: validate,
    patternInvalidMessage: validateMessage,
    isTranslateAvaible: isTranslateAvaible,
    rtl: rtl
  }))), /*#__PURE__*/React.createElement("div", {
    className: "col-lg-4 col-md-6  form-field"
  }, /*#__PURE__*/React.createElement(TextInput, _extends({
    getTranslateValue: getTranslateValue,
    updateContext: updateContext
  }, context['lastNameAR'], {
    validate: validate,
    patternInvalidMessage: validateMessage,
    isTranslateAvaible: isTranslateAvaible,
    rtl: rtl
  }))), /*#__PURE__*/React.createElement("div", {
    className: "col-lg-4 col-md-6  form-field"
  }, /*#__PURE__*/React.createElement(DateField, _extends({
    rtl: rtl
  }, context['passportIssueDate'], {
    updateContext: updateContext,
    validate: validate,
    patternInvalidMessage: validateMessage,
    isOnlyPast: true
  }))), /*#__PURE__*/React.createElement("div", {
    className: "col-lg-4 col-md-6  form-field"
  }, /*#__PURE__*/React.createElement(TextInput, _extends({
    setTranslateValue: setTranslateValue
  }, context['birthPlaceEN'], {
    updateContext: updateContext,
    validate: validate,
    patternInvalidMessage: validateMessage,
    isTranslateAvaible: isTranslateAvaible,
    rtl: rtl
  }))), /*#__PURE__*/React.createElement("div", {
    className: "col-lg-4 col-md-6  form-field"
  }, /*#__PURE__*/React.createElement(TextInput, _extends({
    getTranslateValue: getTranslateValue,
    updateContext: updateContext
  }, context['birthPlaceAR'], {
    validate: validate,
    patternInvalidMessage: validateMessage,
    isTranslateAvaible: isTranslateAvaible,
    rtl: rtl
  }))), /*#__PURE__*/React.createElement("div", {
    className: "col-lg-4 col-md-6  form-field"
  }, /*#__PURE__*/React.createElement(DateField, _extends({}, context['passportExpiryDate'], {
    updateContext: updateContext,
    validate: validate,
    patternInvalidMessage: validateMessage,
    rtl: rtl,
    isOnlyFuture: true
  }))), /*#__PURE__*/React.createElement("div", {
    className: "col-lg-4 col-md-6  form-field"
  }, /*#__PURE__*/React.createElement(TextInput, _extends({
    setTranslateValue: setTranslateValue
  }, context['passportPlaceEN'], {
    updateContext: updateContext,
    validate: validate,
    patternInvalidMessage: validateMessage,
    isTranslateAvaible: isTranslateAvaible,
    rtl: rtl
  }))), /*#__PURE__*/React.createElement("div", {
    className: "col-lg-4 col-md-6  form-field"
  }, /*#__PURE__*/React.createElement(TextInput, _extends({
    getTranslateValue: getTranslateValue,
    updateContext: updateContext
  }, context['passportPlaceAR'], {
    validate: validate,
    patternInvalidMessage: validateMessage,
    isTranslateAvaible: isTranslateAvaible,
    rtl: rtl
  })))))), errorServerMessage.length ? /*#__PURE__*/React.createElement("div", {
    className: "error-message"
  }, errorServerMessage) : ''), requiredRule && /*#__PURE__*/React.createElement("div", {
    className: "module-group-wrap"
  }, /*#__PURE__*/React.createElement(RichText, {
    field: get(policyMessage, 'jss'),
    className: "field__info"
  }))), /*#__PURE__*/React.createElement(ActionsPanel, {
    rtl: rtl,
    actions: panelActions,
    buttonState: panelButtonState
  }), showModal && /*#__PURE__*/React.createElement(Modal, {
    hide: function hide() {
      return setShowModal(false);
    },
    rtl: rtl,
    dictionary: _objectSpread(_objectSpread({}, stepConfig.data), dictionary),
    apiConfig: apiConfig,
    context: context
  }));
};
var commonStyles = "c194ida3";
var rtlStyles = "rbmmieg";
var ltrStyles = "l9sigek";
export default StepRender;